<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <section class="page-tit__wrap">
      <h1 class="page-tit__sub">마이페이지</h1>
      <h2 class="page-tit">취약점 패치 통계 및 이력</h2>
    </section>
    <section class="section-pt">
      <h2 class="section-title">취약점 패치 이력</h2>
    </section>
    <div class="board-list__top">
      <p class="board-list__total">총 {{ patchTotal }}건</p>
      <div class="board-list__search">
        <label for="search-type" class="sr-only">검색 조건</label>
        <p class="board-list__search-tit">KVE</p>
        <label for="search-keyword" class="sr-only"
          >검색어를 입력해주세요</label
        >
        <input
          type="text"
          id="search-keyword"
          v-model="patchSearchInfo.content"
          placeholder="검색어를 입력해주세요"
        />
        <p class="board-list__search-tit">조치 구분</p>
        <select name="" id="search-type" v-model="patchSearchInfo.submitType">
          <option value="">선택해 주세요</option>
          <option value="R">조치 결과 접수</option>
          <option value="P">조치 계획서 접수</option>
        </select>
        <button
          type="button"
          class="btn btn--blue btn--m"
          @click="getPatchList(1)"
        >
          <i class="svg_icon icon_search white"></i>검색
        </button>
      </div>
    </div>
    <!-- v-for 적용 테이블 -->
    <table class="board-list type-m-none-thead">
      <caption>
        조치 접수 목록
      </caption>
      <colgroup>
        <col width="5%" />
        <col width="15%" />
        <col width="30%" />
        <col width="20%" />
        <col width="10%" />
        <col width="10%" />
        <col width="10%" />
      </colgroup>
      <thead>
        <tr>
          <th scope="col">
            <label class="chk">
              <input type="checkbox" class="chk" v-model="isAllChecked" />
            </label>
          </th>
          <th scope="col">등록일</th>
          <th scope="col">KVE</th>
          <th scope="col">대상제품명</th>
          <th scope="col">패치구분</th>
          <th scope="col">조치 가능 여부</th>
          <th scope="col">버전</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in patchItems" :key="item.id" class="clickable-row">
          <td>
            <label class="chk"
              ><input
                type="checkbox"
                class="chk"
                :value="item.kve"
                v-model="checkedItems"
            /></label>
          </td>
          <td class="no-field">
            {{ convertDateFormat(item.patchInfo?.regDate) || "-" }}
          </td>
          <td class="no-field">
            <div class="ellipsis">{{ item.kve }}</div>
          </td>
          <td class="hit-field">{{ item.swNm || "-" }}</td>
          <td class="hit-field">{{ convertPatchType(item.gubun) }}</td>
          <td class="hit-field">
            {{ convertHasActionOk(item.patchInfo?.hasActionOk) }}
          </td>
          <td class="hit-field">{{ item.isMatch }}</td>
        </tr>
      </tbody>
    </table>
    <Paging
      v-model="patchPagingInfo.currentPage"
      :totalItems="patchTotal"
      :visibleCount="patchPagingInfo.limitNum"
      @update:modelValue="getPatchPage"
    />
    <section class="section-pt">
      <h2 class="section-title">취약점 패치 통계</h2>
    </section>
    <div class="board-list__top">
      <p class="board-list__total">총 {{ statsTotal }}건</p>
      <div class="board-list__search">
        <label for="search-type" class="sr-only">검색 조건</label>

        <p class="board-list__search-tit">기준</p>
        <select name="" id="search-type" v-model="statsSearchInfo.searchOption">
          <option value="MONTH">월간</option>
          <option value="QUARTER">분기</option>
          <option value="YEAR">년간</option>
        </select>
        <p class="board-list__search-tit">신고 날짜</p>
        <label for="input4" class="sr-only">신고날짜 시작일 입력</label
        ><input type="date" id="input4" v-model="statsSearchInfo.startDate" />
        <span>~</span>
        <label for="input5" class="sr-only">신고날짜 종료일 입력</label
        ><input type="date" id="input5" v-model="statsSearchInfo.endDate" />

        <button
          type="button"
          class="btn btn--blue btn--m"
          @click="getStatsList(1)"
        >
          <i class="svg_icon icon_search white"></i>검색
        </button>
      </div>
    </div>
    <table class="board-list type-m-none-thead">
      <caption>
        조치 접수 목록
      </caption>
      <colgroup>
        <col width="15%" />
        <col width="65%" />
        <col width="10%" />
        <col width="10%" />
      </colgroup>
      <thead>
        <tr>
          <th scope="col">기준일</th>
          <th scope="col">소프트웨어 이름</th>
          <th scope="col">패치 건수</th>
          <th scope="col">패치 계획 건수</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in statsItems" :key="item.id" class="clickable-row">
          <td class="no-field">
            <div>{{ item.year + item.month }}</div>
          </td>
          <td class="no-field">
            <div class="ellipsis">{{ item.swName || "-" }}</div>
          </td>
          <td class="hit-field">{{ item.totalPatchCnt || "-" }}</td>
          <td class="hit-field">{{ item.totalPatchPlanCnt || "-" }}</td>
        </tr>
      </tbody>
    </table>
    <Paging
      v-model="statsPagingInfo.currentPage"
      :totalItems="statsTotal"
      :visibleCount="statsPagingInfo.limitNum"
      @update:modelValue="getStatsPage"
    />
  </div>
</template>
<script>
import dc from "@/component/DataChk.js";
import dt from "@/component/DateTime.js";
import paging from "@/component/Paging.js";
import tb from "@/component/Table.js";
import dayjs from "dayjs";
import { onMounted, reactive, ref } from "vue";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    //데이터 정의
    const statsSearchInfo = ref({
      sortBy: "_id",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
      makr: "C0129",
      searchOption: "MONTH",
      startDate: dayjs().subtract(1, "year").format("YYYY-MM-DD"),
      endDate: dayjs(new Date()).format("YYYY-MM-DD"),
    });
    const patchSearchInfo = ref({
      sortBy: "_id",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
      searchOption: "TITLE",
      content: "",
      submitType: "",
      tabs: "",
    });
    const savedStatsSearchInfo = ref({
      // getList(1) 후 저장된 검색 조건
      sortBy: "regDate",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
      startDate: dayjs().subtract(1, "year").format("YYYY-MM-DD"),
      endDate: dayjs(new Date()).format("YYYY-MM-DD"),
    });
    const savedPatchSearchInfo = ref({
      // getList(1) 후 저장된 검색 조건
      sortBy: "regDate",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
      searchOption: "TITLE",
      content: "",
      submitType: "",
      tabs: "",
    });
    const statsItems = ref([]);
    const patchItems = ref([]);
    const patchTotal = ref(-1);
    const statsTotal = ref(-1);
    const patchUrl = "/patch/pr/records/patch-his/get";
    const statsUrl = "/patch/pr/records/stats/get";
    const patchCntUrl = "/patch/pr/records/count/patch-his/get";
    const statsCntUrl = "/patch/pr/records/count/stats/get";

    //methods 정의
    const getPatchPage = (page) => {
      // 페이징 클릭 시 목록 조회
      patchPagingInfo.currentPage = page;
      patchPagingInfo.pageNum = page - patchPagingInfo.prePage;
      patchPagingInfo.doubleTab = false;
      getList(
        patchCntUrl,
        patchUrl,
        patchItems,
        patchPagingInfo,
        savedPatchSearchInfo,
        patchSearchInfo,
        2,
        patchTotal
      );
      patchPagingInfo.prePage = page;
    };
    const getStatsPage = (page) => {
      // 통계 페이징 클릭 시 목록 조회
      statsPagingInfo.currentPage = page;
      statsPagingInfo.pageNum = page - statsPagingInfo.prePage; // 클릭한 페이지 기준 차이
      statsPagingInfo.doubleTab = false;
      getList(
        statsCntUrl,
        statsUrl,
        statsItems,
        statsPagingInfo,
        savedStatsSearchInfo,
        statsSearchInfo,
        2,
        statsTotal
      );
      statsPagingInfo.prePage = page;
    };

    const patchPagingInfo = reactive({
      currentPage: 1, // 현재페이지
      prePage: 1, // 이전페이지
      perPage: 10, // n개씩보기
      limitNum: 10, // 화면에 표시할 페이지 수
      type: 1, // 1 = 처음부터 조회, 2 = preKey/nextKey 사용, 3 = n개씩보기 변경
      total: -1,
      pageNum: 0,
      doubleTab: false,
    });
    const statsPagingInfo = reactive({
      currentPage: 1, // 현재페이지
      prePage: 1, // 이전페이지
      perPage: 10, // n개씩보기
      limitNum: 10, // 화면에 표시할 페이지 수
      type: 1, // 1 = 처음부터 조회, 2 = preKey/nextKey 사용, 3 = n개씩보기 변경
      total: -1,
      pageNum: 0,
      doubleTab: false,
    });
    const searchEndpoints = [
      {
        countUrl: patchCntUrl,
        url: patchUrl,
        ref: patchItems,
        savedSearchInfo: savedPatchSearchInfo,
        searchInfo: patchSearchInfo,
        paging: patchPagingInfo,
        total: patchTotal,
      },
      {
        countUrl: statsCntUrl,
        url: statsUrl,
        ref: statsItems,
        savedSearchInfo: savedStatsSearchInfo,
        searchInfo: statsSearchInfo,
        paging: statsPagingInfo,
        total: statsTotal,
      },
    ];
    const getIntegratedSearch = async () => {
      showLoading();
      try {
        const promises = searchEndpoints.map((endpoint) => {
          endpoint.searchInfo.value = dc.trimObject(endpoint.searchInfo.value);
          return getList(
            endpoint.countUrl,
            endpoint.url,
            endpoint.ref,
            endpoint.paging,
            endpoint.savedSearchInfo,
            endpoint.searchInfo,
            1,
            endpoint.total
          );
        });
        await Promise.allSettled(promises);
      } catch (error) {
        console.error(error);
      } finally {
        hideLoading();
      }
    };

    const getList = async (
      countUrl,
      url,
      items,
      pagingInfo,
      savedSearchInfo,
      searchInfo,
      type,
      total
    ) => {
      try {
        const searchPayload = { ...searchInfo.value };
        const axiosSearchInfo = tb.getSearchInfo(
          type,
          { value: searchPayload },
          savedSearchInfo
        );
        pagingInfo.type = type;
        const fetchPromises = [];
        if (type !== 2) {
          total.value = -1;
          const totalPromise = paging
            .total(countUrl, axiosSearchInfo)
            .then((res) => {
              total.value = res;
            });
          fetchPromises.push(totalPromise);
        }

        const itemsPromise = paging
          .getPageItems(url, axiosSearchInfo, pagingInfo)
          .then((res) => {
            items.value = res || [];
            pagingInfo.doubleTab = true;
          });
        // 검색 조건 저장
        tb.saveSearchInfo(type, searchInfo, savedSearchInfo);
        fetchPromises.push(itemsPromise);
        await Promise.all(fetchPromises);
      } catch (error) {
        console.error(error);
        items.value = [];
        if (total) {
          total.value = 0;
        }
      }
    };

    const getPatchList = async (type) => {
      getList(
        patchCntUrl,
        patchUrl,
        patchItems,
        patchPagingInfo,
        savedPatchSearchInfo,
        patchSearchInfo,
        type,
        patchTotal
      );
    };
    const getStatsList = async (type) => {
      getList(
        statsCntUrl,
        statsUrl,
        statsItems,
        statsPagingInfo,
        savedStatsSearchInfo,
        statsSearchInfo,
        type,
        statsTotal
      );
    };
    const convertDateFormat = (date) => {
      return dt.dateTimeFormat(date);
    };
    const convertPatchType = (data) => {
      if (data === "P") {
        return "조치 계획서 접수";
      }
      return "조치 결과 접수";
    };
    const convertHasActionOk = (data) => {
      return data ? "가능" : "불가능";
    };
    // life cycle 정의
    onMounted(() => {
      getIntegratedSearch();
    });
    // html에서 사용될 데이터 정의
    return {
      statsSearchInfo,
      patchSearchInfo,
      savedStatsSearchInfo,
      savedPatchSearchInfo,
      patchPagingInfo,
      statsPagingInfo,
      patchItems,
      patchTotal,
      statsTotal,
      statsItems,
      convertPatchType,
      convertHasActionOk,
      convertDateFormat,
      getPatchPage,
      getStatsPage,
      getStatsList,
      getPatchList,
    };
  },
};
</script>